import { gql } from '@apollo/client';

export const USER_MUTATION = gql`
  mutation getUser($tokenValue: String!) {
    getUser: gorecharge_getUser(arg1: { token: $tokenValue }) {
      data
      status
    }
  }
`;

export const PAY_ORDER = gql`
  mutation payOrder($ref: String!) {
    payOrder: gorecharge_payOrder(args: { payment_code: "thawani", reference: $ref }) {
      data
    }
  }
`;

export const CREATE__ORDER = gql`
  mutation createOrder($evcode: String!, $ref: String!, $lang: String!) {
    createOrder: gorecharge_createOrder(
      args: {
        evcode: $evcode
        payment_method_code: "thawani"
        reference: $ref
        code: $lang
      }
    ) {
      data
      status
    }
  }
`; 